import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { UnreadMessagesModel } from "./widget.model";


@Injectable()
export class WidgetsService {

  constructor(private http: HttpClient) { }

  getUndeliveredSupplierOffers(): Promise<number[]> {
    return this.http.get<number[]>(`${environment.apiUrl}/SupplierRound/GetUndeliveredSupplierOffers`).toPromise();
  }

  getUnreadSupplierOfferMessages(): Promise<UnreadMessagesModel[]> {
    return this.http.get<UnreadMessagesModel[]>(`${environment.apiUrl}/SupplierOffer/GetUnreadMessages`).toPromise();
  }
}
